import React, { Component } from "react"
import styled, { injectGlobal, css } from 'styled-components'
import Link from "gatsby-link"
import { find } from 'lodash'
import { rgba } from 'polished';
import moment from 'moment'

import { Block, Share, MetaTags, ScrollProgress, Footer, Section } from '../components'

import arrowBack from '../assets/icons/arrow-back.svg'

import { warmBrown } from '../styles/themes'
import { container, padding, bgImage, button, bgIcon, innerContainer, hoverState } from '../styles/global'
import { heading2, paragraph, caption, projectIntro } from '../styles/type'
import { media, isClient } from '../styles/utils'
import { grey } from '../styles/colors'

class Article extends Component {

	state = {
        data: []
	}
		
	componentWillMount = () => {
        const data = this.props.previewData || this.props.pathContext
        
        this.setState({
            data: data,
        })
    }

    renderSections = () => {
        const { data } = this.state;
        
        if (data.acf.sections) {
            return data.acf.sections.map((section, i) => {
                const blocks = section.blocks;

                if (section.display_section && section.blocks) {
                    return (
                        <Section
                            key={i}
                            blocks={blocks}
                            section={section}
                        />
                    )
                }
            })
        }
	}
    

  	render() {
        
        const { data } = this.state;

        if(data){

            return (
                <React.Fragment>
                    <ScrollProgress/>

                    <Wrapper>


                        <MetaTags 
                            title={`Paul Conrad Architects — Journal : ${data.title}`}
                            description={data.acf.listing_description ? data.acf.listing_description : ''}
                        />

                        <HeroImage
                            image={data.acf.hero_image.sizes.full_width}
                        />

                        <Opening>
                            <Left>
                                <Title>{data.title}</Title>
                                <Meta>
                                    <CatLink
                                        to={`/journal/section/${data.catSlug}`}
                                    >
                                        {`${data.catTitle}`}
                                    </CatLink> 
                                </Meta>


                            </Left>
                            
                            <Right>
                                <Introduction
                                    dangerouslySetInnerHTML={{__html: data.acf.introduction}}  
                                />
                            </Right>

                        </Opening>
                        
                        {this.renderSections()}

                        <Footer 
                            title={data.title}
                            pageURL={isClient() ? window.location.href : '' }
                            backLink={'/journal'}
                            backLinkText={'All Posts'}
                        />

                    </Wrapper>
                </React.Fragment>
            )	
        }
  	}
}



const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;	
	width: 100%;
	z-index: 2;

    padding-top: 10rem;

    ${media.phone`
        padding-top: 0;
    `}
`


// Hero

const HeroImage = styled.div`
	${innerContainer};
    height: 600px;
    margin-bottom: 10rem;
	background-image: url(${props => props.image});
	${bgImage}

    ${media.laptop`
        height: 480px;
    `}

    ${media.tablet`
        height: 420px;
    `}

    ${media.phone`
        height: 235px;
    `}
`


//// article opening


// layout

const Left = styled.div``
const Right = styled.div``
const Meta = styled.div`
    display:flex;
`

const Opening = styled.div`
    ${innerContainer};
    display: flex;
    flex-direction: row;
    margin-bottom: 15rem;

    ${media.tablet`
        flex-direction: column;
        align-items: center;
    `}

    ${Left}, ${Right} {
		flex: 50%;
		box-sizing: border-box;

        ${media.tablet`
            flex: none;
            width: 360px;
            max-width: 100%;
        `}
    }

    ${Left} {
        padding-right: 2.5rem; /* half gutter size */

        ${media.tablet`
            padding-right: 0;
        `}
    }

    ${Right} {
        padding-left: 2.5rem; /* half gutter size */

        ${media.tablet`
            padding-left: 0;
        `}
    }
`


// type styles

const Title = styled.div`
    margin-bottom: 2rem;
    font-family: 'Scto';
    font-weight: 300;
    font-size: 34px;
    line-height: 40px;
    letter-spacing: -0.5px;

    ${media.laptop`
        font-size: 25.5px;
        line-height: 30px;
        letter-spacing: -0.4px;
    `}
`


const CatLink = styled(Link)`
    ${caption};
`


const Date = styled.div`
    ${caption};
    text-indent: 0!important;
`

const Introduction = styled.div`
    ${media.tablet`
        margin-top: 4rem;
    `}

    &, > * {
        ${paragraph};
    }
`



export default Article





// WEBPACK FOOTER //
// ./src/templates/article.js